import { makeStyles } from '@material-ui/styles';

import { useCurrentUser } from '@bizzabo/entities';

import ManageList from './ManageList';
import Header from './Header';
import { useMeetings } from '../MeetingsTool/MeetingsToolContext';
import useMeetingsData from './useMeetingsData';
import ZeroState from './ZeroState';
import ManageLoader from './ManageLoader';
import TimeZoneHeader from './TimeZoneHeader';
import useUsersMeetings from '../hooks/useUsersMeetings';
import useMeetingsGroups from './useMeetingsGroups';
import useUnreadNotifications from '../hooks/useUnreadNotifications';
import useUpdateMeetingsOnNewNotifications from '../hooks/useUpdateMeetingsOnNewNotifications';

const ManageMeetings: React.FC = () => {
    const { eventId } = useMeetings();
    const {
        data: currentUser,
        isLoading: isCurrentUserLoading,
        isIdle: isCurrentUserIdle,
    } = useCurrentUser(eventId);

    const {
        meetings,
        usersProfileIds,
        isLoading: isLoadingMeetings,
        isFetching: isFetchingMeetings,
    } = useMeetingsData();

    useUpdateMeetingsOnNewNotifications();
    useUnreadNotifications(meetings);

    const {
        data: meetingList,
        isLoading: isMeetingGroupLoading,
        isFetching: isMeetingGroupFetching,
    } = useMeetingsGroups({
        userProfileId: currentUser?.userProfileId,
        meetings,
        isEnabled:
            !isFetchingMeetings &&
            !!meetings?.length &&
            !isCurrentUserLoading &&
            !isCurrentUserIdle,
    });

    const { data: usersData, isLoading: isLoadingUsers } = useUsersMeetings({
        usersProfileIds,
        isFetchingMeetings: isFetchingMeetings,
    });

    const classes = useStyles();

    const isLoading =
        isLoadingMeetings ||
        isLoadingUsers ||
        isCurrentUserLoading ||
        isMeetingGroupLoading ||
        isMeetingGroupFetching;

    const hasMeetingsAndUsers = meetings?.length && usersData?.content?.length;

    return (
        <>
            {isLoading || hasMeetingsAndUsers ? (
                <div className={classes.container}>
                    {isLoading ? (
                        <ManageLoader />
                    ) : (
                        <>
                            <Header />
                            <TimeZoneHeader />
                            <div className={classes.content}>
                                <ManageList
                                    meetingList={meetingList}
                                    users={usersData.content}
                                    currentUser={currentUser}
                                />
                            </div>
                        </>
                    )}
                </div>
            ) : (
                <ZeroState />
            )}
        </>
    );
};

const useStyles = makeStyles(
    () => ({
        container: {
            display: 'flex',
            flexDirection: 'column',
            height: '100%',
        },
        content: {
            overflowY: 'auto',
            padding: '0 30px',
        },
    }),
    { classNamePrefix: 'manage-meetings' }
);

export default ManageMeetings;
